import { render, staticRenderFns } from "./DispatchWorkflowsPage.vue?vue&type=template&id=3c38e9bb&scoped=true"
import script from "./DispatchWorkflowsPage.vue?vue&type=script&lang=js"
export * from "./DispatchWorkflowsPage.vue?vue&type=script&lang=js"
import style0 from "./DispatchWorkflowsPage.vue?vue&type=style&index=0&id=3c38e9bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38e9bb",
  null
  
)

export default component.exports